import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ubs-ofbiz-multi-submit-btn',
  template:  `<button nbButton size="tiny" class="multi-submit-btn" disabled (click)="onSubmitMultiSelect()">Submit Selected</button>`,
  styleUrls: ['./ofbiz-multi-submit-btn.component.scss']
})
export class OfbizMultiSubmitBtnComponent implements OnInit {
  @Output() multiSelectSubmit = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onSubmitMultiSelect():void{
    this.multiSelectSubmit.emit()
  }

}
